import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import cn from 'classnames';
import Select from 'react-select';
import { defaultTo } from 'ramda';

import { handleError, handleSuccess } from '../../util/forms';
import { apiGetEmailDropdownsForCategory } from '../../api/email';
import magic from '../../util/magic';

import Modal from '../Modal';
import EditField from '../Forms/EditField';

const propTypes = {
  id: PropTypes.number,
  approvalMessage: PropTypes.any,
  rejectMessage: PropTypes.any,
  showApproval: PropTypes.bool,
  showReject: PropTypes.bool,
  review: PropTypes.func,
};

class ReviewModal extends Component {
  state = {
    fetchMessageDropdown: false,
    messageDropdown: [],
  };

  loadingMessageDropdown = false;

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.showReject && nextProps.showReject) {
      return { showReject: defaultTo(false, nextProps.showReject), fetchMessageDropdown: true };
    }

    return { showReject: defaultTo(false, nextProps.showReject) };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fetchMessageDropdown && !this.loadingMessageDropdown) {
      this.loadingMessageDropdown = true;

      apiGetEmailDropdownsForCategory(magic.emailMembershipRejection)
        .then(({ data }) => this.setState({ messageDropdown: data.options, fetchMessageDropdown: false }))
        .catch((err) => console.error(err))
        .then(() => (this.loadingMessageDropdown = false));
    }
  }

  render() {
    const {
      onHide,
      values,
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
      isValid,
      approveMessage,
      rejectMessage,
      setFieldValue,
      showApproval,
      showReject,
      status,
    } = this.props;
    const { messageDropdown } = this.state;

    return (
      <Modal
        show={showApproval || showReject}
        onHide={() => onHide()}
        title={`${showApproval ? 'Approve' : 'Reject'} Request`}
      >
        <Modal.Body>
          {showApproval ? approveMessage : rejectMessage}
          {showReject && (
            <EditField
              as={Select}
              bare
              block
              multi
              status={status}
              label="Why was this request rejected?"
              name="messageDropdown"
              onChange={(value) =>
                setFieldValue(
                  'selectedMessages',
                  value.map((choice) => choice.value),
                )
              }
              value={values.selectedMessages}
              options={messageDropdown.map((option) => ({ value: option.id, label: option.title }))}
              error={errors.messageDropdown}
            />
          )}
          <EditField
            block
            as="textarea"
            name="message"
            label={showApproval ? 'Additional Notes' : null}
            status={status}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.message}
            error={errors.message}
          />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => onHide()}>
            Close
          </button>
          <button
            type="submit"
            className={cn('btn', { 'btn-primary': showApproval, 'btn-danger': showReject })}
            disabled={!isValid || isSubmitting}
            onClick={handleSubmit}
          >
            {showApproval ? 'Approve' : 'Reject'}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

ReviewModal.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    props
      .review(props.id, { ...payload, approved: props.showApproval })
      .then(() => handleSuccess(formProps))
      .then(() => props.onHide(true))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: () => ({
    selectedMessages: [],
    message: '',
  }),
  isInitialValid: true,
  validateOnChange: true,
})(ReviewModal);
